/* eslint-disable */
import * as Types from '../../../graphqlTypes';

import { gql } from '@apollo/client';
import { ItemCalculationFragmentDoc, WithDocumentItemTaskInfoFragmentDoc, WithItemPropertiesFragmentDoc, WithProductInfoFragmentDoc, WithDocumentItemCalculationFragmentDoc, DocumentItem_CalculationsFragmentDoc, FieldsAffectedByPropertiesFragmentDoc, FieldsAffectedByAttributeExpressionsFragmentDoc, WithProductFiltersInfoFragmentDoc, TreeItem__DocumentItemFragmentDoc, WithDocumentItemInfoFragmentDoc, WithDocumentItemTreeInfoFragmentDoc, WithDocumentItemVisibilityInfoFragmentDoc, WithDocumentItemChangeOrderInfoFragmentDoc, WithDocumentItemAgreementInfoFragmentDoc, WithDocumentItemDecisionInfoFragmentDoc } from '../Fragments.generated';
import { TemplatesQuoteStatus_TemplateFragmentDoc } from '../../templates/quote/TemplateQuoteStatus.generated';
import { QuoteStatusChip_QuoteFragmentDoc } from '../../quotes/QuoteStatusBadge.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChangeContingencyMutationVariables = Types.Exact<{
  input: Types.ModifyItemContingencyInput;
}>;


export type ChangeContingencyMutation = { modifyItemContingency: { __typename: 'ModifyItemContingencyResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string, needsAgreement: boolean, isPublished: boolean, isBinding: boolean, agreement: Types.Agreement, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, decisionIsContingentItem: boolean, isOptional: boolean, decisionContingentItemPreselection?: boolean | null }, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, isParentContingencyNotPreselected: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } };

export type FinalizeContingencyDecisionMutationVariables = Types.Exact<{
  input: Types.FinalizeContingencyDecisionInput;
}>;


export type FinalizeContingencyDecisionMutation = { finalizeContingencyDecision: { __typename: 'FinalizeContingencyDecisionResult', doc: { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Quote', id: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Requirement', id: string, isPublished: boolean, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> }, item?: { __typename: 'Item', id: string, originVersionNumber?: number | null, decisionIsContingentItem: boolean, isOptional: boolean, decisionContingentItemPreselection?: boolean | null } | null, otherChangedItems: Array<{ __typename: 'Item', id: string, pathForPdf: string, pathSortable: string, rank: number, originVersionNumber?: number | null, isParentContingencyNotPreselected: boolean, hasChildren: boolean }> } };

export type EliminateItemMutationVariables = Types.Exact<{
  input: Types.EliminateItemInput;
}>;


export type EliminateItemMutation = { eliminateItem: { __typename: 'EliminateItemResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string, needsAgreement: boolean, isPublished: boolean, isBinding: boolean, agreement: Types.Agreement, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, isItemEliminated: boolean, decisionIsContingentItem: boolean, isOptional: boolean, decisionContingentItemPreselection?: boolean | null }, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, isAnyParentItemEliminated: boolean, isParentContingencyNotPreselected: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } };

export type ResetEliminateItemMutationVariables = Types.Exact<{
  input: Types.ResetEliminateItemInput;
}>;


export type ResetEliminateItemMutation = { resetEliminateItem: { __typename: 'ResetEliminateItemResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string, needsAgreement: boolean, isPublished: boolean, isBinding: boolean, agreement: Types.Agreement, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, isItemEliminated: boolean, decisionIsContingentItem: boolean, isOptional: boolean, decisionContingentItemPreselection?: boolean | null }, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, isAnyParentItemEliminated: boolean, isParentContingencyNotPreselected: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } };

export type ChangeDecisionMutationVariables = Types.Exact<{
  input: Types.ModifyItemDecisionInput;
}>;


export type ChangeDecisionMutation = { modifyItemDecision: { __typename: 'ModifyItemDecisionResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string, needsAgreement: boolean, isPublished: boolean, isBinding: boolean, agreement: Types.Agreement, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, needsAgreement: boolean, pendingChangeAttributes: any, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionSubitemsPreselection: Array<string>, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, needsAgreement: boolean, pendingChangeAttributes: any, decisionOptionBehaviour: Types.DecisionBehaviorOfSubitems, decisionOptionIsPreselected?: boolean | null, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } };

export type FinalizeSubitemDecisionMutationVariables = Types.Exact<{
  input: Types.FinalizeSubitemDecisionInput;
}>;


export type FinalizeSubitemDecisionMutation = { finalizeSubitemDecision: { __typename: 'FinalizeSubitemDecisionResult', doc: { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Quote', id: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> } | { __typename: 'Requirement', id: string, isPublished: boolean, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> }, item?: { __typename: 'Item', id: string, originVersionNumber?: number | null, parentId?: string | null, pathForPdf: string, pathSortable: string, rank: number, type: Types.ItemType, isRootItem: boolean, isDecisionOption: boolean, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionSubitemsPreselection: Array<string> } | null, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, parentId?: string | null, pathForPdf: string, pathSortable: string, rank: number, isRootItem: boolean, isDecisionOption: boolean, decisionOptionBehaviour: Types.DecisionBehaviorOfSubitems, decisionOptionIsPreselected?: boolean | null, isParentDecisionNotPreselected: boolean, isParentDecisionPreselected: boolean }> } };

export type EliminateDecisionOptionMutationVariables = Types.Exact<{
  input: Types.EliminateDecisionOptionInput;
}>;


export type EliminateDecisionOptionMutation = { eliminateDecisionOption: { __typename: 'EliminateDecisionOptionResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string, needsAgreement: boolean, isPublished: boolean, isBinding: boolean, agreement: Types.Agreement, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, decisionOptionIsPreselected?: boolean | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', authorId: string, reason: string } | null }, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, decisionSubitemsPreselection: Array<string>, isAnyParentItemEliminated: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } };

export type ResetEliminateDecisionOptionMutationVariables = Types.Exact<{
  input: Types.ResetEliminateDecisionOptionInput;
}>;


export type ResetEliminateDecisionOptionMutation = { resetEliminateDecisionOption: { __typename: 'ResetEliminateDecisionOptionResult', doc: { __typename: 'Building', id: string } | { __typename: 'Quote', id: string, needsAgreement: boolean, isPublished: boolean, isBinding: boolean, agreement: Types.Agreement, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null } | { __typename: 'Requirement', id: string, isPublished: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }, item: { __typename: 'Item', id: string, originVersionNumber?: number | null, decisionOptionIsPreselected?: boolean | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', authorId: string, reason: string } | null }, otherChangedItems: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, decisionSubitemsPreselection: Array<string>, isAnyParentItemEliminated: boolean, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null }> } };

export type DocumentItems_Document_Building_Fragment = { __typename: 'Building', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> };

export type DocumentItems_Document_Quote_Fragment = { __typename: 'Quote', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> };

export type DocumentItems_Document_QuoteTemplate_Fragment = { __typename: 'QuoteTemplate', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> };

export type DocumentItems_Document_Requirement_Fragment = { __typename: 'Requirement', id: string, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null }> };

export type DocumentItems_DocumentFragment = DocumentItems_Document_Building_Fragment | DocumentItems_Document_Quote_Fragment | DocumentItems_Document_QuoteTemplate_Fragment | DocumentItems_Document_Requirement_Fragment;

export type DocumentStatus_Document_Building_Fragment = { __typename: 'Building', id: string };

export type DocumentStatus_Document_Quote_Fragment = { __typename: 'Quote', id: string, isPublished: boolean, isBinding: boolean, needsAgreement: boolean, agreement: Types.Agreement };

export type DocumentStatus_Document_QuoteTemplate_Fragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean };

export type DocumentStatus_Document_Requirement_Fragment = { __typename: 'Requirement', id: string, isPublished: boolean };

export type DocumentStatus_DocumentFragment = DocumentStatus_Document_Building_Fragment | DocumentStatus_Document_Quote_Fragment | DocumentStatus_Document_QuoteTemplate_Fragment | DocumentStatus_Document_Requirement_Fragment;

export type ProposedCalculations_ItemFragment = { __typename: 'Item', proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type DecisionMutations_ItemFragment = { __typename: 'Item', id: string, parentId?: string | null, type: Types.ItemType, decisionIsContingentItem: boolean, decisionContingentItemPreselection?: boolean | null, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionSubitemsPreselection: Array<string> };

export const DocumentItems_DocumentFragmentDoc = gql`
    fragment DocumentItems_Document on Document {
  ... on WithDocumentInfo {
    id
  }
  ... on QuoteTemplate {
    items {
      id
      originVersionNumber
    }
  }
  ... on Quote {
    items {
      id
      originVersionNumber
    }
  }
  ... on Requirement {
    items {
      id
      originVersionNumber
    }
  }
  ... on Building {
    items {
      id
      originVersionNumber
    }
  }
}
    `;
export const DocumentStatus_DocumentFragmentDoc = gql`
    fragment DocumentStatus_Document on Document {
  ... on WithDocumentInfo {
    id
  }
  ... on QuoteTemplate {
    ...TemplatesQuoteStatus_Template
  }
  ... on Quote {
    ...QuoteStatusChip_Quote
  }
  ... on Requirement {
    isPublished
  }
}
    ${TemplatesQuoteStatus_TemplateFragmentDoc}
${QuoteStatusChip_QuoteFragmentDoc}`;
export const ProposedCalculations_ItemFragmentDoc = gql`
    fragment ProposedCalculations_Item on Item {
  proposedCalculation {
    ...ItemCalculation
  }
}
    ${ItemCalculationFragmentDoc}`;
export const DecisionMutations_ItemFragmentDoc = gql`
    fragment DecisionMutations_Item on Item {
  id
  parentId
  type
  decisionIsContingentItem
  decisionContingentItemPreselection
  decisionBehaviorOfSubitems
  decisionSubitemsPreselection
}
    `;
export const ChangeContingencyDocument = gql`
    mutation ChangeContingency($input: ModifyItemContingencyInput!) {
  modifyItemContingency(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ... on WithAgreementInfo {
        needsAgreement
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      decisionIsContingentItem
      isOptional
      decisionContingentItemPreselection
    }
    otherChangedItems {
      id
      originVersionNumber
      isParentContingencyNotPreselected
      ...ProposedCalculations_Item
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type ChangeContingencyMutationFn = Apollo.MutationFunction<ChangeContingencyMutation, ChangeContingencyMutationVariables>;

/**
 * __useChangeContingencyMutation__
 *
 * To run a mutation, you first call `useChangeContingencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeContingencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeContingencyMutation, { data, loading, error }] = useChangeContingencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeContingencyMutation(baseOptions?: Apollo.MutationHookOptions<ChangeContingencyMutation, ChangeContingencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeContingencyMutation, ChangeContingencyMutationVariables>(ChangeContingencyDocument, options);
      }
export type ChangeContingencyMutationHookResult = ReturnType<typeof useChangeContingencyMutation>;
export type ChangeContingencyMutationResult = Apollo.MutationResult<ChangeContingencyMutation>;
export type ChangeContingencyMutationOptions = Apollo.BaseMutationOptions<ChangeContingencyMutation, ChangeContingencyMutationVariables>;
export const FinalizeContingencyDecisionDocument = gql`
    mutation FinalizeContingencyDecision($input: FinalizeContingencyDecisionInput!) {
  finalizeContingencyDecision(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ...DocumentItems_Document
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      decisionIsContingentItem
      isOptional
      decisionContingentItemPreselection
    }
    otherChangedItems {
      id
      pathForPdf
      pathSortable
      rank
      originVersionNumber
      isParentContingencyNotPreselected
      hasChildren
    }
  }
}
    ${DocumentItems_DocumentFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}`;
export type FinalizeContingencyDecisionMutationFn = Apollo.MutationFunction<FinalizeContingencyDecisionMutation, FinalizeContingencyDecisionMutationVariables>;

/**
 * __useFinalizeContingencyDecisionMutation__
 *
 * To run a mutation, you first call `useFinalizeContingencyDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeContingencyDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeContingencyDecisionMutation, { data, loading, error }] = useFinalizeContingencyDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeContingencyDecisionMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeContingencyDecisionMutation, FinalizeContingencyDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeContingencyDecisionMutation, FinalizeContingencyDecisionMutationVariables>(FinalizeContingencyDecisionDocument, options);
      }
export type FinalizeContingencyDecisionMutationHookResult = ReturnType<typeof useFinalizeContingencyDecisionMutation>;
export type FinalizeContingencyDecisionMutationResult = Apollo.MutationResult<FinalizeContingencyDecisionMutation>;
export type FinalizeContingencyDecisionMutationOptions = Apollo.BaseMutationOptions<FinalizeContingencyDecisionMutation, FinalizeContingencyDecisionMutationVariables>;
export const EliminateItemDocument = gql`
    mutation EliminateItem($input: EliminateItemInput!) {
  eliminateItem(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ... on WithAgreementInfo {
        needsAgreement
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      isItemEliminated
      decisionIsContingentItem
      isOptional
      decisionContingentItemPreselection
    }
    otherChangedItems {
      id
      originVersionNumber
      isAnyParentItemEliminated
      isParentContingencyNotPreselected
      ...ProposedCalculations_Item
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type EliminateItemMutationFn = Apollo.MutationFunction<EliminateItemMutation, EliminateItemMutationVariables>;

/**
 * __useEliminateItemMutation__
 *
 * To run a mutation, you first call `useEliminateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminateItemMutation, { data, loading, error }] = useEliminateItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEliminateItemMutation(baseOptions?: Apollo.MutationHookOptions<EliminateItemMutation, EliminateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EliminateItemMutation, EliminateItemMutationVariables>(EliminateItemDocument, options);
      }
export type EliminateItemMutationHookResult = ReturnType<typeof useEliminateItemMutation>;
export type EliminateItemMutationResult = Apollo.MutationResult<EliminateItemMutation>;
export type EliminateItemMutationOptions = Apollo.BaseMutationOptions<EliminateItemMutation, EliminateItemMutationVariables>;
export const ResetEliminateItemDocument = gql`
    mutation ResetEliminateItem($input: ResetEliminateItemInput!) {
  resetEliminateItem(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ... on WithAgreementInfo {
        needsAgreement
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      isItemEliminated
      decisionIsContingentItem
      isOptional
      decisionContingentItemPreselection
    }
    otherChangedItems {
      id
      originVersionNumber
      isAnyParentItemEliminated
      isParentContingencyNotPreselected
      ...ProposedCalculations_Item
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type ResetEliminateItemMutationFn = Apollo.MutationFunction<ResetEliminateItemMutation, ResetEliminateItemMutationVariables>;

/**
 * __useResetEliminateItemMutation__
 *
 * To run a mutation, you first call `useResetEliminateItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEliminateItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEliminateItemMutation, { data, loading, error }] = useResetEliminateItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetEliminateItemMutation(baseOptions?: Apollo.MutationHookOptions<ResetEliminateItemMutation, ResetEliminateItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEliminateItemMutation, ResetEliminateItemMutationVariables>(ResetEliminateItemDocument, options);
      }
export type ResetEliminateItemMutationHookResult = ReturnType<typeof useResetEliminateItemMutation>;
export type ResetEliminateItemMutationResult = Apollo.MutationResult<ResetEliminateItemMutation>;
export type ResetEliminateItemMutationOptions = Apollo.BaseMutationOptions<ResetEliminateItemMutation, ResetEliminateItemMutationVariables>;
export const ChangeDecisionDocument = gql`
    mutation ChangeDecision($input: ModifyItemDecisionInput!) {
  modifyItemDecision(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ... on WithAgreementInfo {
        needsAgreement
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      needsAgreement
      pendingChangeAttributes
      decisionBehaviorOfSubitems
      decisionSubitemsPreselection
      ...ProposedCalculations_Item
    }
    otherChangedItems {
      id
      originVersionNumber
      needsAgreement
      pendingChangeAttributes
      decisionOptionBehaviour
      decisionOptionIsPreselected
      isParentDecisionPreselected
      isParentDecisionNotPreselected
      ...ProposedCalculations_Item
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type ChangeDecisionMutationFn = Apollo.MutationFunction<ChangeDecisionMutation, ChangeDecisionMutationVariables>;

/**
 * __useChangeDecisionMutation__
 *
 * To run a mutation, you first call `useChangeDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDecisionMutation, { data, loading, error }] = useChangeDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeDecisionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDecisionMutation, ChangeDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeDecisionMutation, ChangeDecisionMutationVariables>(ChangeDecisionDocument, options);
      }
export type ChangeDecisionMutationHookResult = ReturnType<typeof useChangeDecisionMutation>;
export type ChangeDecisionMutationResult = Apollo.MutationResult<ChangeDecisionMutation>;
export type ChangeDecisionMutationOptions = Apollo.BaseMutationOptions<ChangeDecisionMutation, ChangeDecisionMutationVariables>;
export const FinalizeSubitemDecisionDocument = gql`
    mutation FinalizeSubitemDecision($input: FinalizeSubitemDecisionInput!) {
  finalizeSubitemDecision(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ...DocumentItems_Document
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      parentId
      pathForPdf
      pathSortable
      rank
      type
      isRootItem
      isDecisionOption
      decisionBehaviorOfSubitems
      decisionSubitemsPreselection
    }
    otherChangedItems {
      id
      originVersionNumber
      parentId
      pathForPdf
      pathSortable
      rank
      isRootItem
      isDecisionOption
      decisionOptionBehaviour
      decisionOptionIsPreselected
      isParentDecisionNotPreselected
      isParentDecisionPreselected
    }
  }
}
    ${DocumentItems_DocumentFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}`;
export type FinalizeSubitemDecisionMutationFn = Apollo.MutationFunction<FinalizeSubitemDecisionMutation, FinalizeSubitemDecisionMutationVariables>;

/**
 * __useFinalizeSubitemDecisionMutation__
 *
 * To run a mutation, you first call `useFinalizeSubitemDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeSubitemDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeSubitemDecisionMutation, { data, loading, error }] = useFinalizeSubitemDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeSubitemDecisionMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeSubitemDecisionMutation, FinalizeSubitemDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeSubitemDecisionMutation, FinalizeSubitemDecisionMutationVariables>(FinalizeSubitemDecisionDocument, options);
      }
export type FinalizeSubitemDecisionMutationHookResult = ReturnType<typeof useFinalizeSubitemDecisionMutation>;
export type FinalizeSubitemDecisionMutationResult = Apollo.MutationResult<FinalizeSubitemDecisionMutation>;
export type FinalizeSubitemDecisionMutationOptions = Apollo.BaseMutationOptions<FinalizeSubitemDecisionMutation, FinalizeSubitemDecisionMutationVariables>;
export const EliminateDecisionOptionDocument = gql`
    mutation EliminateDecisionOption($input: EliminateDecisionOptionInput!) {
  eliminateDecisionOption(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ... on WithAgreementInfo {
        needsAgreement
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      decisionOptionElimination {
        authorId
        reason
      }
      decisionOptionIsPreselected
    }
    otherChangedItems {
      id
      originVersionNumber
      decisionSubitemsPreselection
      isAnyParentItemEliminated
      ...ProposedCalculations_Item
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type EliminateDecisionOptionMutationFn = Apollo.MutationFunction<EliminateDecisionOptionMutation, EliminateDecisionOptionMutationVariables>;

/**
 * __useEliminateDecisionOptionMutation__
 *
 * To run a mutation, you first call `useEliminateDecisionOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEliminateDecisionOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eliminateDecisionOptionMutation, { data, loading, error }] = useEliminateDecisionOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEliminateDecisionOptionMutation(baseOptions?: Apollo.MutationHookOptions<EliminateDecisionOptionMutation, EliminateDecisionOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EliminateDecisionOptionMutation, EliminateDecisionOptionMutationVariables>(EliminateDecisionOptionDocument, options);
      }
export type EliminateDecisionOptionMutationHookResult = ReturnType<typeof useEliminateDecisionOptionMutation>;
export type EliminateDecisionOptionMutationResult = Apollo.MutationResult<EliminateDecisionOptionMutation>;
export type EliminateDecisionOptionMutationOptions = Apollo.BaseMutationOptions<EliminateDecisionOptionMutation, EliminateDecisionOptionMutationVariables>;
export const ResetEliminateDecisionOptionDocument = gql`
    mutation ResetEliminateDecisionOption($input: ResetEliminateDecisionOptionInput!) {
  resetEliminateDecisionOption(input: $input) {
    doc {
      ... on WithDocumentInfo {
        id
      }
      ... on QuoteTemplate {
        resolvedAsReadModelVersionNumber
      }
      ... on WithAgreementInfo {
        needsAgreement
      }
      ... on WithCalculation {
        proposedCalculation {
          ...ItemCalculation
        }
      }
      ...DocumentStatus_Document
    }
    item {
      id
      originVersionNumber
      decisionOptionElimination {
        authorId
        reason
      }
      decisionOptionIsPreselected
    }
    otherChangedItems {
      id
      originVersionNumber
      decisionSubitemsPreselection
      isAnyParentItemEliminated
      ...ProposedCalculations_Item
    }
  }
}
    ${ItemCalculationFragmentDoc}
${DocumentStatus_DocumentFragmentDoc}
${ProposedCalculations_ItemFragmentDoc}`;
export type ResetEliminateDecisionOptionMutationFn = Apollo.MutationFunction<ResetEliminateDecisionOptionMutation, ResetEliminateDecisionOptionMutationVariables>;

/**
 * __useResetEliminateDecisionOptionMutation__
 *
 * To run a mutation, you first call `useResetEliminateDecisionOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEliminateDecisionOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEliminateDecisionOptionMutation, { data, loading, error }] = useResetEliminateDecisionOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetEliminateDecisionOptionMutation(baseOptions?: Apollo.MutationHookOptions<ResetEliminateDecisionOptionMutation, ResetEliminateDecisionOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEliminateDecisionOptionMutation, ResetEliminateDecisionOptionMutationVariables>(ResetEliminateDecisionOptionDocument, options);
      }
export type ResetEliminateDecisionOptionMutationHookResult = ReturnType<typeof useResetEliminateDecisionOptionMutation>;
export type ResetEliminateDecisionOptionMutationResult = Apollo.MutationResult<ResetEliminateDecisionOptionMutation>;
export type ResetEliminateDecisionOptionMutationOptions = Apollo.BaseMutationOptions<ResetEliminateDecisionOptionMutation, ResetEliminateDecisionOptionMutationVariables>;